import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import * as actions from 'app/actions/sap-synchronization';
import { SapConnectionStatus, SapEquipmentMeta } from 'app/models/reducers/sap-synchronization';

export interface SapSynchronizationState {
  acceptSapConnectorUsageAgreementLoading: boolean;
  testSapConnectionLoading: boolean;
  sapConnectionStatus: SapConnectionStatus;
  sapEquipmentMeta: SapEquipmentMeta;
  responseData: unknown;
}

export const initialState: SapSynchronizationState = {
  acceptSapConnectorUsageAgreementLoading: false,
  testSapConnectionLoading: false,
  sapConnectionStatus: SapConnectionStatus.UNKNOWN,
  sapEquipmentMeta: {
    sapEquipment: null,
    sapEquipmentLoadingHasError: false,
    loadingSapEquipment: false
  },
  responseData: null
};

export const sapSynchronizationReducer = createReducer(
  initialState,
  on(actions.AcceptSapConnectorUsageAgreement, state => ({ ...state, acceptSapConnectorUsageAgreementLoading: true })),
  on(actions.AcceptSapConnectorUsageAgreementSuccess, state => ({ ...state, acceptSapConnectorUsageAgreementLoading: false })),
  on(actions.AcceptSapConnectorUsageAgreementFail, state => ({ ...state, acceptSapConnectorUsageAgreementLoading: false })),
  on(actions.TestSapConnection, state => ({ ...state, testSapConnectionLoading: true })),
  on(actions.TestSapConnectionSuccess, (state, action) => ({
    ...state,
    testSapConnectionLoading: false,
    sapConnectionStatus: action.sapConnectionStatus
  })),
  on(actions.TestSapConnectionFail, state => ({
    ...state,
    testSapConnectionLoading: false,
    sapConnectionStatus: SapConnectionStatus.OFFLINE
  })),
  on(actions.getSapEquipment, state => ({
    ...state,
    sapEquipmentMeta: {
      ...state.sapEquipmentMeta,
      loadingSapEquipment: true
    }
  })),
  on(actions.getSapEquipmentSuccess, (state, action) => ({
    ...state,
    sapEquipmentMeta: {
      ...state.sapEquipmentMeta,
      sapEquipment: action.sapEquipment,
      loadingSapEquipment: false,
      sapEquipmentLoadingHasError: false
    }
  })),
  on(actions.getSapEquipmentFail, state => ({
    ...state,
    sapEquipmentMeta: {
      ...state.sapEquipmentMeta,
      sapEquipment: null,
      loadingSapEquipment: false,
      sapEquipmentLoadingHasError: true
    }
  })),
  on(actions.resetSapEquipmentInformation, state => ({
    ...state,
    sapEquipmentMeta: {
      ...state.sapEquipmentMeta,
      loadingSapEquipment: false,
      sapEquipmentLoadingHasError: false,
      sapEquipment: null
    }
  })),
  on(actions.skipSapEquipmentLoading, state => ({
    ...state,
    sapEquipmentMeta: {
      ...state.sapEquipmentMeta,
      loadingSapEquipment: false,
      sapEquipmentLoadingHasError: false
    }
  })),
  on(actions.sendTestRequestSuccess, (state, action) => ({
    ...state,
    responseData: action.responseData
  }))
);

export const featureSelectorKey = 'sap-synchronization';

export const sapSynchronizationFeature = createFeature({
  name: featureSelectorKey,
  reducer: sapSynchronizationReducer
});

export const {
  name,
  reducer,
  selectAcceptSapConnectorUsageAgreementLoading,
  selectTestSapConnectionLoading,
  selectSapConnectionStatus,
  selectSapEquipmentMeta,
  selectResponseData
} = sapSynchronizationFeature;

export const getSapEquipment = createSelector(selectSapEquipmentMeta, (state: SapEquipmentMeta) => state?.sapEquipment || null);
export const getloadingSapEquipment = createSelector(
  selectSapEquipmentMeta,
  (state: SapEquipmentMeta) => state?.loadingSapEquipment ?? false
);
export const getSapEquipmentLoadingHasError = createSelector(
  selectSapEquipmentMeta,
  (state: SapEquipmentMeta) => state?.sapEquipmentLoadingHasError ?? false
);
